import { LoadingButton } from '@mui/lab'
import { CircularProgress, Typography } from '@mui/material'
import { webApiService } from '@services/index'
import MUIDataTable from 'mui-datatables'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'

const UnassignedSupplyPage = () => {
  const [data, setData] = useState<{ loading: boolean, listSupply: any[], hideSingleButton: boolean, html: string }>({ loading: false, listSupply: [], hideSingleButton: false, html: '' })
  const { enqueueSnackbar } = useSnackbar()

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'id_request_st',
      label: 'N° OT',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'id_supply',
      label: 'N° Insumo',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'name',
      label: 'Insumo',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'sku',
      label: 'SKU INSUMO',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'inventory',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <LoadingButton hidden={data.hideSingleButton} variant='contained' color='warning' className='shadow-none' onClick={() => assign(tableMeta.rowData)}>Asignar</LoadingButton>
          )
        }

      }
    }
  ]

  const assign = async (data: any) => {
    console.log('🚀 ~ assign ~ data:', data)
    setData({ ...data, loading: true })
    webApiService.assingSupply(data[0]).then(res => {
      loadData()
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData({ ...data, loading: false })
    })
  }

  const assignMass = async (seleccionados: any) => {
    console.log('🚀 ~ assign ~ data:', seleccionados.data)
    const indices = seleccionados.data.map((el: any) => el.index)
    console.log('🚀 ~ assignMass ~ indices:', indices)
    const ids = data.listSupply.filter((_el, idx) => indices.includes(idx)).map((el) => el.id)
    console.log('🚀 ~ assignMass ~ ids:', ids)

    setData({ ...data, loading: true, html: '' })
    let html = '----- INICIO -----<br/>'
    for (const id of ids) {
      // eslint-disable-next-line no-loop-func
      await webApiService.assingSupply({ idOrderSupply: id }).then((res) => {
        console.log('🚀 ~ awaitwebApiService.AssignTech ~ res:', res)
        html += '<p>' + id + ' - ' + res.message + '</p>'
        // eslint-disable-next-line no-loop-func
      }).catch((err) => {
        console.log('🚀 ~ awaitwebApiService.sendMails ~ err:', err)
        html += '<p>' + id + ' - ' + err.response.data.message + '</p>'
      })
      setData({ ...data, html, loading: true })
    }
    html += '----- FIN -----<br/>'
    loadData(html)
  }

  const loadData : (html?: string) => void = async (html = '') => {
    setData({ ...data, loading: true, html })
    const ret = await webApiService.getAllUnassigned().then(res => res.data)
    console.log('Data de useEffect => ', ret)
    setData({ ...data, loading: false, listSupply: ret, html })
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <div>
      <div className='container-xxl '>
        <div className='row gy-3 my-4'>
          <div className='col-12 my-2'>
            <Typography variant='h6' className='title mb-3'>
              ASIGNAR INSUMOS
            </Typography>

            <div className='shadow-sm rounded bg-white p-3'>
              {
                    data.loading
                      ? (
                        <div className='text-center'><CircularProgress size={20} /> Cargando...</div>
                        )
                      : null
                }
              <div className={data.html === '' ? 'bg-black p-0 text-white mt-2' : 'bg-black p-2 text-white mt-2'} dangerouslySetInnerHTML={{ __html: data.html }} />
              {
                    !data.loading
                      ? (
                        <div className='tabla-ot' data-tour='tabla-ot'>

                          <MUIDataTable
                            title=''
                            data={data.listSupply}
                            columns={columns}
                            options={{
                              selectableRowsHideCheckboxes: false,
                              print: false,
                              download: false,
                              viewColumns: false,
                              textLabels: {
                                selectedRows: { text: 'Filas seleccionadas' }
                              },
                              onRowSelectionChange: (currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[] | undefined) => {
                                console.log('🚀 ~ SuppliesStockPage ~ allRowsSelected:', allRowsSelected)
                                if (allRowsSelected.length > 0) {
                                  setData({ ...data, hideSingleButton: true })
                                } else {
                                  setData({ ...data, hideSingleButton: false })
                                }
                              },
                              customToolbarSelect: selectedRows => {
                                console.log('selectedRows', selectedRows.data.length)
                                return (
                                  <div><LoadingButton variant='contained' color='primary' className='mx-1' onClick={() => assignMass(selectedRows)}>Asignar ({selectedRows.data.length} insumos)</LoadingButton></div>
                                )
                              }
                            }}
                          />
                        </div>
                        )
                      : null
                }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UnassignedSupplyPage
